import { RouteObject } from "../../interfaces/navigation";
import React from "react";
import CongratulationsPage from "../CongratulationsPage";

const EntryPoint = React.lazy(() => import("../../containers/Register/RegisterContainer"));

export const registerRoutes: RouteObject[] = [
    {
        title: "Register",
        path: "/register",
        component: <EntryPoint/>
    },
    {
        title: "Congratulations",
        path: "/register/congratulations",
        component: <CongratulationsPage title={"Ya eres parte de Linze."} text={"Encuentra tu próximo auto o publica el tuyo con solo un par de clics. ¡Un nuevo camino te espera!"} />
    }
];